
class EnvHelper {
    public static isDevelopmentQa = () => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'ZZ2 Sensor';
        } else if (ENV_NAME === 'qa') {
            return 'ZZ2 Sensor QA';
        } else if (ENV_NAME === 'dev') {
            return 'ZZ2 Sensor DEV';
        } else {
            return 'ZZ2 Sensor ENV NOT FOUND';
        }
    };
}

export default EnvHelper;